import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const Headline2 = props => (
  <SvgIcon {...props} viewBox="0 0 32 32">
    <path d="M26.21 13.030c0.423 0 0.768 0.36 0.768 0.804v0.36c0 0.444-0.345 0.806-0.77 0.806h-4.44c-0.423 0-0.768-0.362-0.768-0.805v-0.29c0-0.19 0.064-0.374 0.182-0.52l2.918-3.602c0.75-0.935 1.017-1.392 1.017-1.747 0-1.014-0.878-1.065-1.054-1.065-0.38 0-1.025 0.142-1.052 1.088-0.010 0.436-0.352 0.782-0.768 0.782h-0.345c-0.424 0-0.77-0.362-0.77-0.805 0-1.731 1.262-3.036 2.936-3.036 1.702 0 2.936 1.298 2.936 3.084 0 1.13-0.754 2.065-1.484 2.966l-1.59 1.98h2.283zM17 9c0.553 0 1 0.447 1 1v16c0 0.553-0.447 1-1 1-0.552 0-1-0.447-1-1v-7h-9v7c0 0.553-0.447 1-1 1-0.552 0-1-0.447-1-1v-16c0-0.553 0.448-1 1-1 0.553 0 1 0.447 1 1v7h9v-7c0-0.553 0.448-1 1-1z" />
  </SvgIcon>
);

export default Headline2;
